import React from "react";
import * as S from "./Styles";

interface ImageProps {
  src: string;
  alt: string;
  width?: string;
  height?: string;
  useShadow?: boolean;
  useRadius?: boolean;
  onClick?: () => void;
  clickable?: boolean;
}

const Image = ({ src, alt, width, height, useShadow, useRadius, onClick, clickable }: ImageProps) => {
  const image = (
    <S.Img
      src={src}
      alt={alt}
      width={width}
      height={height}
      $useShadow={useShadow}
      $useRadius={useRadius}
      onClick={onClick}
      $clickable={clickable}
    />
  );

  if (onClick) {
    return (
      <S.ImageButton type="button" onClick={onClick} aria-label={`Åpne bilde: ${alt}`}>
        {image}
      </S.ImageButton>
    );
  }

  return image;
};

export default Image;
